<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <div
      class="reveal project-reject-modal"
      ref="specifyReasonModal"
      :id="id"
      data-reveal
    >
      <div class="modal-container">
        <slot name="header">
          <p class="modal-pure-text">{{ $t('project.docs.rejectAlert') }}</p>
        </slot>
        <textarea
          type="text"
          v-model="rejectReason"
          style="color: #0C3A58"
          required
        />
        <span
          class="form-error is-visible appr-error-message"
          v-if="apprErrHint"
        >
          {{ apprErrHint }}
        </span>
      </div>
      <attach-docs
        :resourceId="resourceId"
        :btnName="$t('project.docs.uploadDocs')"
      />
      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="specifyReasonModal.close()"
          aria-label="Close reveal"
        >{{ $t('action.cancel') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          @click="reject()"
        >{{ $t('action.reject') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import notification from '@/utils/notification'
import AttachDocs from '@/modules/projects/AttachDocs'
import { getKey } from '@/api/common/request'
import { mapGetters } from 'vuex'
import { PROJECT_FOLDER_STATUS } from '@/modules/projects/consts'
export default {
  name: 'RejectModal',
  components: {
    AttachDocs,
  },
  data () {
    return {
      apprErrHint: '',
      rejectReason: '',
      rejecteeId: null,
      resourceId: '',
    }
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  methods: {
    openspecifyReasonModal () {
      this.specifyReasonModal.open()
    },
    closespecifyReasonModal () {
      this.specifyReasonModal.close()
    },
    clearClose () {
      this.clearContent()
      this.specifyReasonModal.close()
      EventBus.emit(`modules_projects_rejectModal_doCloseSuccess_${this.id}`)
    },
    async getResourceId () {
      try {
        return await getKey()
      } catch (err) {
        notification.fireNotification(false, this.$i18n.t('project.docs.initUploadError'))
      }
    },
    reject () {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.apprErrHint = this.$i18n.t('hint.enterRejectReason')
      } else {
        this.doReject()
      }
    },

    doReject () {
      if (this.currentUser && this.rejecteeId) {
        const actionHistory = {
          id: this.resourceId,
          approver: {
            id: this.currentUser.id,
            name: this.currentUser.displayName || this.currentUser.name,
            username: this.currentUser.username,
          },
          detail: { rejectReason: this.rejectReason },
          actionType: PROJECT_FOLDER_STATUS.REJECT,
        }
        EventBus.emit(`modules_projects_rejectModal_doReject_${this.id}`, {actionHistory, id: this.rejecteeId})
      } else {
        notification.fireNotification(false, this.$i18n.t('error.checkInput'))
      }
    },

    clearContent () {
      this.rejectReason = ''
    },

    async init (rejecteeId) {
      this.apprErrHint = ''
      this.rejectReason = ''
      this.rejecteeId = null
      this.resourceId = ''
      if (!this.specifyReasonModal) {
        this.specifyReasonModal = await new Foundation.Reveal($(`#${this.id}`), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.rejecteeId = rejecteeId
      this.resourceId = await this.getResourceId()

      await this.openspecifyReasonModal()
    },
  },
  computed: {
    ...mapGetters('user', ['currentUser']),
  },
  mounted () {
    EventBus.on(`modules_projects_rejectModal_doClose_${this.id}`, () => {
      this.clearClose()
    })
  },
  beforeDestroy () {
    if (this.specifyReasonModal) {
      this.specifyReasonModal.close()
      this.specifyReasonModal.destroy()
    }
    $(`#${this.id}`).remove()
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
.project-reject-modal textarea {
  width: 100%;
}
.appr-error-message {
  margin-top: 10px
}

</style>
